export default function Footer() {
  return (
    <div
      style={{
        color: 'gray',
        textAlign: 'center',
        background: '#dde0e2',
        paddingBottom: 20,
        fontSize: 12,
      }}
    >
      <p style={{ width: '90%', margin: 'auto' }}>
        @ Copyright 2022 <strong>EASYTECH TECNOLOGIA LTDA. </strong>
        Todos os direitos reservados. {process.env.REACT_APP_VERSION}
      </p>
      <p style={{ marginTop: 5 }}>
        <a
          target="_blank"
          href="https://modulocker.com/termos-condicoes-de-uso/"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          Termos de Uso
        </a>
        <a
          target="_blank"
          href="https://modulocker.com/politica-de-privacidade"
          rel="noreferrer"
          style={{ textDecoration: 'underline', marginLeft: 10 }}
        >
          Política de Privacidade
        </a>
      </p>
    </div>
  );
}
